module.exports = __webpack_public_path__ + "img/proust.2c9f1dc6.jpg";